import { handleActions } from 'redux-actions';
import immutable from 'object-path-immutable'
import * as actions from './actions';
import { sessionLoadSuccess } from "../auth-user/actions";

const defaultState = {
  email: '',
  password: '',
  formErrors: {},
  isLoading: false,
  error: null,
  emailSignInMethod: false,
  resetEmailSended: null
};

const authByEmailReducer = handleActions(
  {
    [actions.setEmail]: (state, action) => ({ ...state, email: action.payload }),
    [actions.setPassword]: (state, action) => {
      return immutable(state)
        .set('formErrors.password', null)
        .set('password', action.payload).value();
    },
    [actions.setFormErrors]: (state, action) => ({ ...state, formErrors: action.payload }),
    [actions.emailSignInRequest]: (state, action) => ({ ...state, isLoading: true }),
    [actions.setEmailSignInMethod]: (state, action) => ({ ...state, emailSignInMethod: action.payload }),
    [actions.emailSignInSuccess]: (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: null,
        emailSignInMethod: false,
      }
    },
    [actions.emailSignInFailed]: (state, action) => ({ ...state, isLoading: false, error: action.payload }),

    [actions.passwordResetRequest]: (state, action) => ({ ...state, isLoading: true }),
    [actions.passwordResetSuccess]: (state, action) => ({
        ...state, 
        isLoading: false, 
        error: null, 
        resetEmailSended: true
    }),
    [actions.passwordResetFailed]: (state, action) => ({ ...state, isLoading: false, error: action.payload }),
    [actions.donePasswordReset]: (state, action) => ({ 
      ...state, 
      isLoading: false, 
      error: null, 
      resetEmailSended: false 
    }),
    
    [sessionLoadSuccess]: (state, action) => {
      return {
        ...state,
        email: '',
        password: '',
        formErrors: {},
        emailSignInMethod: false,
      }
    }
  },
  defaultState
);

export default authByEmailReducer;


// WEBPACK FOOTER //
// ./src/app/modules/auth/store/auth-by-email/reducer.ts